import { fmtG } from '../../utils/format';
import { MetricCard } from './MetricCard';
interface Props {
  value: number;
  colorClass?: string;
  className?: string;
}
export function GnarrInfluencedCard({
  value,
  colorClass = 'c-gold',
  className
}: Props) {
  return <MetricCard label="GNARR Influenced" value={fmtG(value)} sub="total opp GNARR (created qtr)" colorClass={colorClass} className={className} data-id="element-518" data-mp="ejbv8as5c9xt" />;
}